module.exports = __webpack_public_path__ + "static/media/3.1a982b67.svg";